import { graphql, useStaticQuery } from 'gatsby';

export type FooterSection = {
	className?: string;
};

export enum ItemType {
	newPage = 'newPage',
	social = 'social',
	phone = 'phone',
}

export type FooterItemContent = {
	label: string;
	url: string;
	type: ItemType;
	ariaText: string;
	className?: string;
};

export type FooterColumnHeader = {
	className?: string;
	label: string;
	url?: string;
};

export type FooterColumn = {
	className?: string;
	header?: FooterColumnHeader;
	items: FooterItemContent[];
};

export type FooterMenu = {
	menuClassName?: string;
	columns: FooterColumn[];
} & FooterSection;

export type NovartisFooter = {
	trademark?: boolean;
} & FooterSection;

export type Configuration = {
	brandFooter: FooterMenu;
	novartisFooter: NovartisFooter;
} & FooterSection;

export default function useFooter(): Configuration {
	const { config } = useStaticQuery<{ config: Configuration }>(graphql`
		query footerConfigurationQuery {
			config: footerConfiguration {
				className
				brandFooter {
					className
					menuClassName
					columns {
						className
						header {
							className
							label
							url
						}
						items {
							label
							url
							type
							ariaText
							className
						}
					}
				}
				novartisFooter {
					className
					trademark
				}
			}
		}
	`);

	return config;
}
